module.exports = __webpack_public_path__ + "img/Simple Yellow.a9cb1414.jpg";